import { RootState } from "src/store/store";

/**
 *
 */
export namespace ClaimsSelector {
    export const policyList = (state: RootState) => state.claims?.policyList!;
    export const claimList = (state: RootState) => state.claims?.claimList;
}